const STORAGE_KEY = "fwdlook.com:state";

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(STORAGE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};
export const saveState = (state) => {
	try {
		const serializedState = JSON.stringify(state);
		localStorage.setItem(STORAGE_KEY, serializedState);
	} catch (err) {
		// Ignore write errors
	}
};
// Ineffective. State is overriden in store.js on init. Calling this without alerting store somehow is useless
// export const clearState = () => {
//   console.log('clear state?')
//   localStorage.removeItem(STORAGE_KEY);
// };

// export default class StateLoader {
//   loadState() {
//     try {
//       let serializedState = localStorage.getItem(STORAGE_KEY);

//       if (serializedState === null) {
//         return this.initializeState();
//       }

//       return JSON.parse(serializedState);
//     } catch (err) {
//       return this.initializeState();
//     }
//   }

//   saveState(state) {
//     try {
//       let serializedState = JSON.stringify(state);
//       localStorage.setItem(STORAGE_KEY, serializedState);
//     } catch (err) {}
//   }

//   initializeState() {
//     return {
//       //state object
//     };
//   }
// }



// WEBPACK FOOTER //
// ./src/StateLoader.js